module.exports = __webpack_public_path__ + "static/media/Ouro.f95e6821.png";